import { render, staticRenderFns } from "./NoItemsDashboard.vue?vue&type=template&id=6b5b9130&scoped=true"
import script from "./NoItemsDashboard.vue?vue&type=script&lang=js"
export * from "./NoItemsDashboard.vue?vue&type=script&lang=js"
import style0 from "./NoItemsDashboard.vue?vue&type=style&index=0&id=6b5b9130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5b9130",
  null
  
)

export default component.exports